import AlgoliaCollection from '@components/collection/AlgoliaCollection'
import SearchClient, { pathToSearchState } from '@lib/algolia'
import { useRouter } from 'next/router'

interface SearchProps {
  algoliaIndex?: string
  resultsState?: any
}

export default function Search({ algoliaIndex, resultsState }: SearchProps) {
  let { query, asPath, pathname } = useRouter()
  let { q } = query
  if (!q) q = ''

  const index =
    algoliaIndex ?? process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_PRIMARY_INDEX!
  const searchState = pathToSearchState(asPath)

  return (
    <>
      <div className="wrapper" data-id="collection-wrapper">
        <h1 className="text-xl py-5">
          <span className="">Showing results for</span>
          <span className="font-bold">{` "${q}"`}</span>
        </h1>
        <AlgoliaCollection
          searchClient={SearchClient}
          indexName={index}
          exactIndexName={index}
          searchState={searchState}
          resultsState={resultsState}
          defaultCategory=""
          searchTerm={q && Array.isArray(q) ? q[0] : q}
          pathname={pathname}
        />
      </div>
    </>
  )
}
